import type { ConfirmArrivalLineValues } from '@/features/receive-confirm-arrival';
import type { ReceiveTableRow } from '@/entities/receive';
import { RECEIVE_LOCATION_TYPE } from '@/entities/receive';

/**
 * One line of the convoy form. Quantities in **inventory units**, as in the
 * single receipt; unlike it, the receive location lives on the line — the PO's
 * decision, and legacy's per-row dropdown.
 */
export interface ReceiveConvoyLineValues extends ConfirmArrivalLineValues {
  targetLocationId: string;
  /** Storage-area seqno; `null` when the location has none or none is picked. */
  targetLocationSpaceSeq: number | null;
}

/** One truck: what is stored once per receipt shipment rather than per line. */
export interface ReceiveConvoyShipmentValues {
  shipmentId: string;
  comments: string;
  transportDocNumber: string;
  lines: ReceiveConvoyLineValues[];
}

export interface ReceiveConvoyFormValues {
  /** `yyyy-MM-dd`, one date for the whole convoy. */
  actualDateOfReceipt: string;
  /** One explanation for the convoy, stored on each receipt that carries a loss. */
  explanationOfLosses: string;
  printGoodsReceivedNote: boolean;
  shipments: ReceiveConvoyShipmentValues[];
}

/** The convoy row the modal was opened from; name and destination are fallback header text. */
export interface ReceiveConvoyTarget {
  /** Composite `siteId~id` — the dashboard's `locationId` of the convoy row. */
  convoyId: string;
  convoyName?: string;
}

/** Narrows a dashboard row to a convoy target; anything but a convoy location row is `null`. */
export const toReceiveConvoyTarget = (row: ReceiveTableRow): ReceiveConvoyTarget | null =>
  row.rowType === 'location' && row.locationType === RECEIVE_LOCATION_TYPE.CONVOY && row.locationId
    ? { convoyId: row.locationId, convoyName: row.locationLabel }
    : null;
